const PAYMENT_LINK_GETTERS = {
  id: 'paymentLink/id',
  formData: 'paymentLink/formData',
  isLoading: 'paymentLink/isLoading',
  isActionLoading: 'paymentLink/actionLoading',
  items: 'paymentLink/items',
  sorting: 'paymentLink/sort',
  chronologySort: 'paymentLink/chronologySort',
  search: 'paymentLink/search',
  dateRange: 'paymentLink/dateRange',
  statuses: 'paymentLink/statuses',
  currentPaymentLink: 'paymentLink/currentPaymentLink',
  total: 'paymentLink/total',
  statistics: 'paymentLink/statistics',
}

const PAYMENT_LINK_DISPATCHERS = {
  setId: 'paymentLink/setId',
  createPaymentLink: 'paymentLink/createPaymentLink',
  updatePaymentLink: 'paymentLink/updatePaymentLink',
  updatePaymentLinkStatus: 'paymentLink/updatePaymentLinkStatus',
  recreatePaymentLink: 'paymentLink/recreatePaymentLink',
  getPaymentLinks: 'paymentLink/getPaymentLinks',
  getPaymentLinkById: 'paymentLink/getPaymentLinkById',
  uploadAvatar: 'paymentLink/uploadAvatar',
  deleteAvatar: 'paymentLink/deleteAvatar',
  resetPage: 'paymentLink/resetPage',
  resetStore: 'paymentLink/resetStore',
  resetPaymentLinkDetails: 'paymentLink/resetPaymentLinkDetails',
  changePage: 'paymentLink/changePage',
  onSelectSort: 'paymentLink/onSelectSort',
  onSelectChronologySort: 'paymentLink/onSelectChronologySort',
  onSearch: 'paymentLink/onSearch',
  resetSearch: 'paymentLink/resetSearch',
  onDateRangeChange: 'paymentLink/onDateRangeChange',
  resetDateRange: 'paymentLink/resetDateRange',
  onStatusesChange: 'paymentLink/onStatusesChange',
  resetStatuses: 'paymentLink/resetStatuses',
  resetFilters: 'paymentLink/resetFilters',
  deletePaymentLink: 'paymentLink/deletePaymentLink',
  addPaymentLink: 'paymentLink/addPaymentLink',
  _addItemAfterUpdate: 'paymentLink/_addItemAfterUpdate',
  _changeItemAfterUpdate: 'paymentLink/_changeItemAfterUpdate',
  downloadExcelReport: 'paymentLink/downloadExcelReport',
}

export { PAYMENT_LINK_GETTERS, PAYMENT_LINK_DISPATCHERS }
